'use client';

import type { ReactNode } from 'react';
import { cn } from '~/utils';

type ActivitySearchHeroAnimatedWrapperProps = {
    children: ReactNode;
    className?: string;
};

/**
 * Sizes the activity-search PLP hero. Mobile: content height (title + mode tabs) so the filter
 * surface can flow directly beneath it (see ActivitySearchFiltersOverlay). Desktop: a single
 * constant height so the filter / AI surface bar straddles the hero edge as one row, and toggling
 * Filters ⇄ AI never jumps the hero height.
 */
export function ActivitySearchHeroAnimatedWrapper({
    children,
    className,
}: ActivitySearchHeroAnimatedWrapperProps) {
    return (
        <div
            className={cn(
                'relative z-header -mt-header min-h-header w-full overflow-hidden',
                // 280px under a 6rem header; grows with the header when the USP bar is on.
                'h-auto lg:h-[calc(184px+var(--funkey-header-height))]',
                className,
            )}
        >
            {children}
        </div>
    );
}
